export default __webpack_public_path__ + "images/b676f509589567f59bd947a170e2e9b1-state_government.webp";